import TLang from "model/application/Lang";
import { IDashboard } from "model/entities/Dashboard";

export function getDashboardName(dashboard: IDashboard, lang: TLang) {
  const defaultDashboards =
    lang.containers.dashboards.subCategories.dashboards.defaultDashboards;
  return defaultDashboards[dashboard.id] || dashboard.title;
}
